import { authFetch, sapFetch } from "../../api";

export const getUserTestScore = async (payload) => {
  try {
    const response = await authFetch(
      `profile/show-test-scores`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload), 
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching academic profile:", err.message);
    throw err;
  }
};
export const updateTestScore = async (payload) => {
  try {
    const response = await authFetch(
      `profile/edit-test-scores`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload), 
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching academic profile:", err.message);
    throw err;
  }
};
export const saveTestScore = async (payload) => {
  try {
    const response = await authFetch(
      `profile/save-new-test-scores`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload), 
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching academic profile:", err.message);
    throw err;
  }
};


// get all the tests
export const getAllTests = async () => {
  try {
    const response = await authFetch(
      `profile/check-validations-tests`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching tests:", err.message);
    throw err;
  }
}